import { gql } from "@apollo/client";

export const SET_ORGANIZATION_PARAMETERS = gql`
  mutation SetOrganizationParameters(
    $values: JSONObject
    $enabled: JSONObject
  ) {
    setOrganizationParameters(values: $values, enabled: $enabled) {
      id
    }
  }
`;

const organizationParameters = { SET_ORGANIZATION_PARAMETERS };

export default organizationParameters;
